import { useMemo } from 'react';

const getAngularService = (name: string) => {
  const injector = angular.element(document.body).injector();
  if (!injector || !injector.get) {
    throw new Error(`Couldn't find angular injector to get "${name}" service`);
  }

  const service = injector.get(name);
  if (!service) {
    throw new Error(`Couldn't find "${name}" angular service`);
  }

  return service;
};

export const useAngularService = (name: string) => {
  return useMemo(() => {
    return getAngularService(name);
  }, [name]);
};

export default getAngularService;
